const KEY = "@MeuLance:Token";

export const getToken = () => localStorage.getItem(KEY);

export function setToken(token: string) {
  localStorage.setItem(KEY, token);
}

export function removeToken() {
  localStorage.removeItem(KEY);
  window.location.replace("/");
}

export function clearToken() {
  localStorage.removeItem(KEY);
}
